<template>
  <div ref="infoboxContainer">
    <slot></slot>
  </div>
</template>

<script>
import Utils from '../utils'
import BingConversions from '../services/BingConversions'
import ComponentBase from './ComponentBase'

const infoboxEvents = Object.freeze([
  'click',
  'infoboxChanged',
  'mouseenter',
  'mouseleave'
])

export default {
  name: 'bing-map-infobox',
  mixins: [ComponentBase],
  props: {
    options: {
      required: false,
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      itemType: 'infobox',
      allowedEvents: infoboxEvents
    }
  },
  inject: ['getMap'],
  watch: {
    options (value) {
      let infobox = this.getItem()

      if (infobox) {
        let options = this.convertOptions(value || {})

        infobox.setOptions(options)
      }
    }
  },
  methods: {
    convertOptions (value) {
      let options =
        (value ? Utils.deepClone(value) : Utils.deepClone(this.options)) || {}

      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          switch (prop) {
            case 'location':
              if (typeof options.location === 'object') {
                options.location = BingConversions.toMapLocation(
                  options.location
                )
              }
              break
            case 'offset':
              if (typeof options.offset === 'object') {
                options.offset = BingConversions.toMapPoint(options.offset)
              }
              break
          }
        }
      }
      return options
    },
    hasHtmlTemplate () {
      return !!(
        this.$slots &&
        this.$slots.default &&
        this.$slots.default.length
      )
    },
    setCustomHtml () {
      let infobox = this.getItem()
      if (infobox) {
        let template = this.$refs.infoboxContainer.innerHTML
        infobox.setHtmlContent(template)
      }
    },
    render () {
      let map = this.getMap()
      let infobox = this.getItem()

      if (map) {
        if (infobox) {
          this.destroy()
        }

        let options = this.convertOptions()
        let location = options && options.location

        if (typeof location !== 'object') {
          location = map.getCenter()
          options.location = location
          options.visible = false
        }

        infobox = this.setItem(new Microsoft.Maps.Infobox(location, options))
        infobox.setMap(map)
      }
    },
    destroy () {
      let infobox = this.getItem()

      try {
        if (infobox) {
          let map = this.getMap()

          if (map) {
            infobox.setMap(null)
          }
        }
      } finally {
        this.setItem(null)
      }
    }
  },
  mounted () {
    this.render()
    this.setCustomHtml()
  },
  updated () {
    this.setCustomHtml()
  },
  beforeDestroy () {
    this.destroy()
  }
}
</script>
